import React from "react";
import SEO from "../components/SEO";
import ResearchStacks from "../components/ResearchStacks";

export default function Stacks() {
  return (
    <div data-testid="stacks-index-page">
      <SEO
        title="Research Stacks — Compounds Commonly Researched Together"
        description="Curated research stacks of peptides commonly studied together, with automatic stack pricing at checkout."
        path="/stacks"
      />
      <div className="max-w-7xl mx-auto px-6 pt-16">
        <div className="overline">RESEARCH STACKS</div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light mt-3">Curated research stacks.</h1>
      </div>
      <ResearchStacks />
    </div>
  );
}
